<template>
  <div class="animated fadeIn">
    <loading v-if="vLoading" />
    <v-col lg="12" class="ml-auto"></v-col>
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <v-btn elevation="6" outlined small>S</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          ذخیره پیش‌نویس <br /><br />
          <v-btn elevation="6" outlined small>P</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          نسخه چاپی استعلام <br /><br />
          <v-btn elevation="6" outlined small>R</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          ریست کردن اقلام سفارش <br /><br />
          <v-btn elevation="6" outlined small>D</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          تحلیل هوشمند اقلام سفارش<br /><br />
          <v-btn elevation="6" outlined small>F</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          ورود به مود تسریع فرآیند محاسبات<br /><br />

          <v-btn elevation="6" outlined small>Shift</v-btn> ورود به حالت تعیین
          قیمت و بالعکس
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <b-tabs pills card content-class="mt-3">
      <b-tab :title="orderInfo.status" active>
        <b-card>
          <template v-slot:header>
            <v-row :class="customer.customer_priority">
              <v-col cols="7" class="mt-4">
                <h4>کد پرونده: {{ orderInfo.orderCode }}</h4>

                <h5>نام مشتری: {{ orderInfo.customerName }}</h5>
                <h5>رتبه مشتری: {{ customer.customer_priority }}</h5>
                <h5>شماره درخواست مشتری: {{ orderInfo.originalRequestId }}</h5>
                <h5>کارشناس مشتری: {{ orderInfo.contactName }}</h5>
                <h5>
                  نوع استعلام:
                  {{
                    orderInfo.orderType
                      ? orderTypes.filter(
                          (x) => x.value == orderInfo.orderType
                        )[0].text
                      : "-"
                  }}
                </h5>
              </v-col>
              <v-col cols="5" class="mt-4">
                <v-col>
                  <v-row>
                    <v-col>
                      <h4>وضعیت پرونده: {{ orderInfo.status }}</h4>
                      <h5>تاریخ ثبت استعلام: {{ orderInfo.registerDate }}</h5>
                      <h5>ثبت اولیه توسط: {{ orderInfo.ownerName }}</h5>
                      <h5>
                        کارشناس بازرگانی:
                        {{ orderInfo.assigneeName }}
                      </h5>
                      <h5>الگوی استعلام: {{ formTemplate }}</h5>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
            <hr />
            <v-row>
              <v-col cols="8">
                <b-btn
                  variant="warning"
                  class="mr-1"
                  @click="draft()"
                  v-shortkey.once="['ctrl' + 's']"
                  @shortkey="draft()"
                  >ذخیره پیش‌نویس</b-btn
                >
                <b-btn
                  variant="dark"
                  class="mr-1"
                  @click="goToPrintPreview('technical')"
                  v-shortkey.once="['ctrl' + 'p']"
                  @shortkey="goToPrintPreview('technical')"
                  >نسخه چاپی استعلام</b-btn
                >
                <b-btn
                  variant="danger"
                  class="mr-1"
                  @click="resetItems()"
                  v-shortkey.once="['ctrl' + 'r']"
                  @shortkey="resetItems()"
                  >ریست کردن اقلام</b-btn
                >
                <b-btn
                  variant="success"
                  class="mr-1"
                  @click="analyzeAll()"
                  v-shortkey.once="['ctrl' + 'd']"
                  @shortkey="analyzeAll()"
                  >تحلیل همه اقلام</b-btn
                >
              </v-col>
              <v-col cols="4">
                <p v-if="!makeItFast">
                  به منظور سبک شدن بار محاسباتی این صفحه و تسریع فرآیند میتوانید
                  از دکمه زیر استفاده کنید
                </p>
                <b-btn
                  v-if="!makeItFast"
                  variant="secondary"
                  class="mr-1"
                  @click="fasten()"
                  v-shortkey.once="['ctrl' + 'f']"
                  @shortkey="fasten()"
                  >جدول استاتیک</b-btn
                >
                <p v-if="makeItFast">
                  میتوانید با استفاده از دکمه‌های ریست کردن اقلام و تحلیل همه
                  اقلام، اقلام را به صورت خودکار تحلیل کنید و سپس با کلیک روی
                  دکمه زیر، جداول را قابل ویرایش کنید.
                </p>
                <b-btn
                  v-if="makeItFast"
                  variant="secondary"
                  class="mr-1"
                  @click="fasten()"
                  v-shortkey.once="['ctrl' + 'f']"
                  @shortkey="fasten()"
                  >بازگشت به حالت ویرایش</b-btn
                >
              </v-col>
            </v-row>
          </template>
          <br />
          <b-card
            class="shadow mb-5 bg-white rounded"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <template v-slot:header>
              <v-row>
                <v-col cols="6">
                  <h6 style="display: inline">بررسی نهایی استعلام</h6>
                </v-col>
              </v-row>
            </template>

            <v-row class="mb-3 item-ckeditor">
              <v-col cols="10">
                <ckeditor
                  v-if="!showCustomerTerms"
                  v-model="orderInfo.customerTerms"
               :editor="editor"
                  :config="editorConfig"
                ></ckeditor>
                <div
                  v-if="showCustomerTerms"
                  v-html="orderInfo.customerTerms"
                  style="border: 1px solid black"
                  class="p-1 rounded"
                />
              </v-col>
              <v-col cols="2">
                <b-btn
                  variant="warning"
                  class="mr-1"
                  style="float: left"
                  @click="toggleCustomerTerms()"
                  >{{
                    showCustomerTerms ? "ویرایش متن بالا" : "ثبت تغییرات"
                  }}</b-btn
                >
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="5">
                <v-text-field
                  type="text"
                  label="پیدا کن"
                  v-model="bulkEditFrom"
                  dense
                  outlined
                >
                </v-text-field
              ></v-col>
              <v-col cols="5"
                ><v-text-field
                  type="text"
                  label="جایگزین کن"
                  v-model="bulkEditTo"
                  dense
                  outlined
                ></v-text-field
              ></v-col>
              <v-col cols="2"
                ><b-btn
                  variant="primary"
                  class="mr-1"
                  style="float: left"
                  @click="doBulkEdit()"
                  >جایگزینی</b-btn
                ></v-col
              >
            </v-row>
            <v-row>
              جایگزینی در ستون‌های زیر انجام شود:
              <v-switch
                v-for="field in replaceFields"
                :key="field.key"
                v-model="field.value"
                :label="field.label"
                class="mx-2"
              ></v-switch>
            </v-row>

            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <div v-if="makeItFast">
                <p>
                  به منظور کاهش بار محاسباتی و تسریع فرآیند، قابلیت ویرایش جدول
                  اقلام حذف شده است.. میتوانید با استفاده از دکمه بازگشت به حالت
                  ویرایش یا کلیدهای ترکیبی
                  <v-btn elevation="6" outlined small>F</v-btn>
                  +
                  <v-btn elevation="6" outlined small>Ctrl</v-btn>
                  صفحه را به حالت ویرایش برگردانید
                </p>
                <b-table
                  v-if="makeItFast"
                  responsive
                  small
                  show-empty
                  :items="filtered"
                  :fields="myFields.filter((x) => x.key != 'selected')"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma;
                      "
                    >
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma;
                      "
                    >
                      {{ data.value }}
                    </div>
                  </template>
                </b-table>
              </div>
              <b-table
                v-if="!makeItFast"
                responsive
                small
                show-empty
                :items="filtered"
                :fields="myFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      font-family: Tahoma;
                    "
                  >
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      font-family: Tahoma;
                    "
                  >
                    {{ data.value }}
                  </div>
                </template>
                <template slot="top-row">
                  <td v-for="field in myFields" :key="field.key">
                    <b-form-input
                      v-if="
                        field.label != '#' &&
                        field.key != 'operation' &&
                        field.key != 'selected'
                      "
                      v-model="filters[field.key]"
                      :placeholder="field.label"
                    ></b-form-input>
                    <p v-else-if="field.key == 'operation'">جستجو</p>
                    <b-btn
                      v-else-if="field.key == 'selected'"
                      variant="dark"
                      class="m-1"
                      @click="toggleSelectAll()"
                      >همه/هیچ</b-btn
                    >
                  </td>
                </template>

                <template v-slot:cell(selected)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-checkbox
                      v-model="data.item.selected"
                      @change="syncUpdateTable()"
                    ></b-form-checkbox>
                  </div>
                </template>
                <template v-slot:cell(type)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <v-select
                      label="نوع"
                      :items="typeOptions"
                      v-model="data.item.type"
                      outlined
                      dense
                    />
                  </div>
                </template>
                <template v-slot:cell(customerIndex)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-input
                      v-model="data.item.customerIndex"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-btn
                      variant="danger"
                      class="m-1"
                      @click="delOffer(data.index)"
                      >x</b-btn
                    >
                    <b-btn
                      variant="success"
                      class="m-1"
                      @click="copyItem(data.item, data.index)"
                      >کپی</b-btn
                    >
                    <b-btn
                      variant="warning"
                      class="m-1"
                      @click="analyzeItem(data.item, data.index)"
                      v-if="data.item.description.split('&').length > 1"
                      >تحلیل</b-btn
                    >
                  </div>
                </template>

                <template v-slot:cell(number)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <v-text-field
                      v-model="data.item.number"
                      type="number"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                </template>

                <template v-slot:cell(length)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.length"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(details)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.details"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(diameter)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.diameter"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(dimensionStandard)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.dimensionStandard"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(cover)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.cover"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(material)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.material"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(description)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.description"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
              </b-table>
              <hr />
              <b-table
                responsive
                small
                show-empty
                :items="updateAllItems"
                :fields="myFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
                :busy="updateTableBusy"
              >
                <template v-slot:head()="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      font-family: Tahoma;
                    "
                  >
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(customerIndex)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-input
                      v-model="data.item.customerIndex"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(selected)="data">
                  <div dir="rtl" style="font-family: Tahoma">
                    {{ filtered.filter((x) => x.selected).length }}
                    قلم انتخاب شده است
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-btn
                      variant="danger"
                      class="m-1"
                      @click="bulkUpdate()"
                      :disabled="
                        !tempOrderItems.filter((x) => x.selected).length
                      "
                      >آپدیت</b-btn
                    >
                  </div>
                </template>

                <template v-slot:cell(number)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <v-text-field
                      v-model="data.item.number"
                      type="number"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                </template>

                <template v-slot:cell(length)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.length"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(details)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.details"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(diameter)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.diameter"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(dimensionStandard)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.dimensionStandard"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(cover)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.cover"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(material)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.material"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(description)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.description"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
              </b-table>
            </b-card>
            <v-row class="item-ckeditor">
              <v-col cols="10">
                <ckeditor
                  v-if="!showPurchaseTemrs"
                  v-model="purchaseTerms"
                 :editor="editor"
                  :config="editorConfig"
                ></ckeditor>
                <div
                  v-if="showPurchaseTemrs"
                  v-html="purchaseTerms"
                  style="border: 1px solid black"
                  class="p-2 rounded"
                />
              </v-col>
              <v-col cols="2">
                <b-btn
                  variant="warning"
                  class="mr-1"
                  style="float: left"
                  @click="togglePurchaseTerms()"
                  >{{
                    showPurchaseTemrs ? "ویرایش متن پایین" : "ثبت تغییرات"
                  }}</b-btn
                >
              </v-col>
            </v-row>
            <hr />
            <a
              class="btn btn-primary mr-1 ml-2 mb-3 mt-0 text-white"
              style="float: right"
              :href="'/' + role + '/order/' + $route.params.id"
              target="_blank"
            >
              مشاهده پرونده سفارش
            </a>
            <b-btn
              variant="warning"
              class="mr-1"
              style="float: left"
              @click="draft()"
              >ذخیره پیش‌نویس</b-btn
            >
            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="submitQuote()"
              v-if="orderInfo.status == 'تایید تعیین قیمت توسط مشتری'"
              :disabled="
                !(
                  role == 'queryOrganizer' ||
                  role == 'Manager' ||
                  role == 'salesManager'
                )
              "
              >تایید اقلام استعلام</b-btn
            >
          </b-card>
          <br />
        </b-card>
      </b-tab>
      <b-tab title="آخرین اقلام استعلام" v-if="!vLoading">
        <b-table
          responsive
          show-empty
          :items="JSON.parse(orderInfo.orderItems)"
          :fields="myFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary"
          style="font-family: Tahoma !important"
        >
          <template v-slot:head()="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>
          <template v-slot:cell(number)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{ (1 * data.item.number).toLocaleString() }}
            </div>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    CKEditor,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      guide: false,
      selectedItems: [],
      editSelectedModal: false,
      bulkEditFrom: "",
      bulkEditTo: "",
      role: "",

      fields: [
        { key: "operation", label: "" },
        { key: "type", label: "نوع کالا" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsCI: [
        { key: "operation", label: "" },
        { key: "type", label: "نوع کالا" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],

      formTemplate: "",
      orderTypes: [
        { value: "full", text: "مالی" },
        { value: "technical", text: "فنی" },
      ],
      hasCustomerIndex: false,
      hasSizeStandard: true,
      allOrders: [],
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
          ],
        ],
        height: 200,
      },
      purchaseTerms: "",
      showPurchaseTemrs: true,
      showCustomerTerms: true,
      customerInfo: {},
      orderInfo: {},
      tempOrderItems: [],
      onlyChangePrice: false,
      filterFile: "",
      isBusyFile: false,
      itemsFile: [],
      fieldsFile: [
        { key: "index", label: "#" },
        { key: "date", label: "تاریخ آپلود" },
        { key: "name", label: "نام فایل" },
        // { key: "subject", label: "توضیحات" },
        { key: "uploaderName", label: "فرد بارگذاری کننده" },
        { key: "download", label: "دریافت" },
      ],
      journals: [],
      filters: {
        details: "",
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
        index: "",
        operation: "",
      },
      filtersHistory: {
        details: "",
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
        index: "",
        operation: "",
      },
      deleteDialog: false,
      ordersTotalRows: 0,
      staticOrdersTotalRows: 0,
      agents: [],
      agentsTotalRows: 0,
      staticAgentsTotalRows: 0,
      customer: {},
      customerOrdersFields: [
        { key: "index", label: "ردیف" },
        { key: "orderCode", label: "کد استعلام" },
        { key: "originalRequestId", label: "شماره درخواست" },
        { key: "registerDate", label: "تاریخ" },
        { key: "status", label: "وضعیت" },
      ],
      customerOrdersIsBusy: true,
      customerOrdersFilter: null,
      currentPageOrder: 1,
      agentsFilter: null,
      agentsIsBusy: true,
      currentPageContact: 1,
      agentsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام رابط" },
        { key: "internal", label: "داخلی" },
        { key: "role", label: "سمت" },
        { key: "phone", label: "تلفن" },
        { key: "phone2", label: "تلفن 2" },
        { key: "fax", label: "فاکس" },
        { key: "mobile", label: "موبایل" },
        { key: "email", label: "ایمیل" },
        { key: "address", label: "آدرس" },
        { key: "postalCode", label: "کد پستی" },
        // { key: "operation", label: "عملیات" },
      ],
      replaceFields: [
        { key: "details", label: "توضیحات تکمیلی", value: false },
        { key: "number", label: "واحد", value: false },
        { key: "length", label: "طول", value: false },
        { key: "diameter", label: "قطر", value: false },
        { key: "dimensionStandard", label: "استاندارد ابعاد", value: false },
        { key: "cover", label: "پوشش", value: false },
        { key: "material", label: "متریال", value: false },
        { key: "description", label: "شرح کالا", value: false },
        { key: "type", label: "نوع کالا", value: false },
      ],
      updateAllItems: [
        {
          details: "",
          number: "",
          length: "",
          diameter: "",
          dimensionStandard: "",
          cover: "",
          material: "",
          description: "",
        },
      ],
      updateTableBusy: false,
      typeOptions: [
        { value: "پیچ", text: "پیچ" },
        { value: "مهره", text: "مهره" },
        { value: "واشر", text: "واشر" },
        { value: "دست", text: "دست" },
        { value: "سایر", text: "سایر" },
      ],
      makeItFast: true,
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    fasten() {
      this.vLoading = true;
      this.makeItFast = !this.makeItFast;
      setTimeout(() => {
        this.vLoading = false;
      }, 1000);
    },
    doBulkEdit() {
      var bulkEditFields = this.replaceFields.filter((x) => x.value);
      // bulkEditItems = JSON.stringify(this.tempOrderItems);
      // bulkEditItems = bulkEditItems.replaceAll(
      //   this.bulkEditFrom,
      //   this.bulkEditTo
      // );
      // this.tempOrderItems = JSON.parse(bulkEditItems);

      this.tempOrderItems.forEach((item) => {
        bulkEditFields.forEach((element) => {
          item[element.key] = item[element.key].replaceAll(
            this.bulkEditFrom,
            this.bulkEditTo
          );
        });
      });
    },
    resetItems() {
      this.vLoading = true;
      var myNewItems = JSON.parse(this.orderInfo.orderItems);
      myNewItems.forEach((item) => {
        item.type = "دست";
      });
      myNewItems.forEach((item, index) => {
        item.index = index + 1;
      });
      this.tempOrderItems = myNewItems;
      setTimeout(() => {
        this.vLoading = false;
      }, 200);
    },
    goToPrintPreview(type) {
      let routeData = this.$router.resolve({
        path:
          "/" +
          this.role +
          "/printPreview/" +
          type +
          "/" +
          this.$route.params.id,
      });
      window.open(routeData.href, "_blank");
    },
    onFilteredContact(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.agentsTotalRows = filteredItems.length;
      this.currentPageContact = 1;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    submitQuote() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/queryInspection",
        {
          orderId: this.$route.params.id,
          customerTerms: this.orderInfo.customerTerms,
          terms: this.purchaseTerms,
          tempOrderItems: JSON.stringify(this.tempOrderItems),
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            router.push("/" + this.role + "/dashboard/");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    showGetCustomerDialog() {
      this.getCustomerDialog = true;
    },
    showFollowCustomerDialog() {
      this.followCustomerDialog = true;
    },
    draft() {
      this.toast("در حال ذخیره سازی... لطفا چند لحظه صبر کنید", "warning");
      Axios.post(
        this.baseUrl + "/ppkpms/order/draft",
        {
          orderId: this.$route.params.id,
          customerTerms: this.orderInfo.customerTerms,
          terms: this.purchaseTerms,
          tempOrderItems: JSON.stringify(this.tempOrderItems),
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("پیش‌نویس با موفقیت ذخیره شد", "success");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    delOffer(order) {
      this.tempOrderItems.splice(order, 1);
    },
    delBatch(order) {
      this.batchData.splice(order, 1);
    },
    copyItem(item, index) {
      this.tempOrderItems.splice(index + 1, 0, {
        totalPrice: item.totalPrice,
        perPrice: item.perPrice,
        number: item.number,
        length: item.length,
        diameter: item.diameter,
        dimensionStandard: item.dimensionStandard,
        cover: item.cover,
        material: item.material,
        description: item.description,
        details: item.details,
        customerIndex: item.customerIndex,
        index: parseInt(Number(item.index) * 10 + 1) / 10,
      });
    },
    analyzeAll() {
      this.vLoading = true;
      var myAllItems = JSON.parse(this.orderInfo.orderItems);
      myAllItems = myAllItems
        .map((x) => x.description.split("&"))
        .reduce((a, b) => a.concat(b), []);
      setTimeout(() => {
        this.tempOrderItems.forEach((item, index) => {
          this.analyzeItem(item, index);
        });
      }, 500);

      setTimeout(() => {
        if (myAllItems.length == this.tempOrderItems.length)
          this.vLoading = false;
        else this.analyzeAll();
      }, 100);
    },
    analyzeItem(item, index) {
      if (parseInt(item.index) == item.index) {
        var myNumber = item.number;
        var myLength = item.length;
        var myDiameter = item.diameter;
        var myCover = item.cover;
        var myCustomerIndex = item.customerIndex;
        var myIndex = item.index;
        var myDetails = item.details;
        var myType = item.type;

        var myDescriptions = item.description.split("&");
        var myDimensionStandards = "";
        var myMaterials = "";
        try {
          myMaterials = item.material.split("&");
        } catch (error) {
          console.log(error, item);
          myMaterials = "";
        }
        try {
          myDimensionStandards = item.dimensionStandard.split("&");
        } catch (error) {
          console.log(error, item);
          myDimensionStandards = "";
        }

        if (myDescriptions.length > 1) {
          try {
            myDescriptions.forEach((element, index2) => {
              var finalDimensionStandards;
              var finalMaterials;
              var finalDescriptions;
              var finalNumber = myNumber;
              var finalLength = myLength;
              var finalType = myType;
              try {
                if (myDimensionStandards.length > 1)
                  finalDimensionStandards = myDimensionStandards[index2].trim();
                else finalDimensionStandards = myDimensionStandards[0].trim();
              } catch (error) {
                console.log(error, item);
                finalDimensionStandards = "";
              }
              try {
                finalMaterials = myMaterials[index2].trim();
              } catch (error) {
                console.log(error, item);
                finalMaterials = "";
              }
              try {
                finalDescriptions = myDescriptions[index2].trim();
                if (/^\d$/.test(finalDescriptions[0])) {
                  if (/^\d$/.test(finalDescriptions[1])) {
                    finalNumber =
                      finalNumber *
                      (10 * Number(finalDescriptions[0]) +
                        Number(finalDescriptions[1]));

                    finalDescriptions = finalDescriptions.substring(2).trim();

                    var descriptionLength = finalDescriptions.length;
                  } else {
                    finalNumber = finalNumber * Number(finalDescriptions[0]);
                    finalDescriptions = finalDescriptions.substring(1).trim();

                    var descriptionLength = finalDescriptions.length;
                  }
                  if (finalDescriptions[descriptionLength - 1] == "S") {
                    finalDescriptions = finalDescriptions
                      .substring(0, descriptionLength - 1)
                      .trim();
                  }
                }
              } catch (error) {
                console.log(error, item);
                finalDescriptions = "";
              }

              try {
                var tempDescription = finalDescriptions.toLowerCase();
                if (tempDescription.indexOf("nut") >= 0) {
                  finalLength = "";
                  finalType = "مهره";
                } else if (tempDescription.indexOf("washer") >= 0) {
                  finalLength = "";
                  finalType = "واشر";
                } else if (tempDescription.indexOf("plate") >= 0) {
                  finalLength = "";
                  finalType = "سایر";
                } else if (tempDescription.indexOf("sleeve") >= 0) {
                  finalLength = "";
                  finalType = "سایر";
                } else finalType = "پیچ";
              } catch (error) {
                // console.log(error, item);
              }

              this.tempOrderItems.splice(index + index2 + 1, 0, {
                number: finalNumber,
                length: finalLength,
                diameter: item.diameter,
                dimensionStandard: finalDimensionStandards,
                cover: item.cover,
                material: finalMaterials,
                description: finalDescriptions.replace("HEX ", "HEX. "),
                details: item.details,
                customerIndex: item.customerIndex,
                type: finalType,
                index: parseInt(Number(item.index) * 10 + index2 + 1) / 10,
              });
            });
          } catch (error) {
            // console.log(error, item);
          }

          this.delOffer(index);
        } else {
          try {
            var finalDescriptions = item.description.trim();
            var finalLength = item.length.trim();
            var finalType = "دست";
            var tempDescription = finalDescriptions.toLowerCase();
            if (tempDescription.indexOf("nut") >= 0) {
              finalLength = "";
              finalType = "مهره";
            } else if (tempDescription.indexOf("washer") >= 0) {
              finalLength = "";
              finalType = "واشر";
            } else if (tempDescription.indexOf("plate") >= 0) {
              finalLength = "";
              finalType = "سایر";
            } else if (tempDescription.indexOf("sleeve") >= 0) {
              finalLength = "";
              finalType = "سایر";
            } else finalType = "پیچ";

            this.tempOrderItems[index].type = finalType;
            this.tempOrderItems[index].length = finalLength;
          } catch (error) {
            console.log(error, item);
          }
        }
      }
    },
    downloadCSV() {
      let a = document.createElement("a");
      let exportItems = this.items.map((item) => {
        return {
          perPrice: item.perPrice,
          number: item.number,
          length: item.length,
          diameter: item.diameter,
          dimensionStandard: item.dimensionStandard,
          cover: item.cover,
          material: item.material,
          description: item.description,
        };
      });
      a.href =
        "data:text/csv;charset=utf-8,\uFEFF" +
        encodeURIComponent(ConvertToCSV(JSON.stringify(exportItems)));
      a.download = "temp" + new Date() + ".csv";
      a.click();
    },
    togglePurchaseTerms() {
      this.showPurchaseTemrs = !this.showPurchaseTemrs;
    },
    toggleCustomerTerms() {
      this.showCustomerTerms = !this.showCustomerTerms;
    },
    delAll() {
      this.deleteDialog = true;
    },
    hideModal(name) {
      name = false;
    },
    editSelected() {
      this.editSelectedModal = true;
    },
    getTaskInfo() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/getInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.orderInfo = res.data;
            this.formTemplate = this.orderInfo.productsTemplate || "pk1";
            this.orderInfo.files = JSON.parse(this.orderInfo.files);
            this.tempOrderItems = this.orderInfo.tempOrderItems;
            this.customerTerms = this.orderInfo.customerTerms;
            this.purchaseTerms = this.orderInfo.terms;
            this.journals = this.orderInfo.history;
            this.discount = this.orderInfo.discount;
            this.orderVat = this.orderInfo.orderVat;
            this.hasSizeStandard = this.orderInfo.orderHasSizeStandard;
            this.hasCustomerIndex = this.orderInfo.hasCustomerIndex;

            this.tempOrderItems
              ? (this.tempOrderItems = JSON.parse(this.tempOrderItems))
              : (this.tempOrderItems = []);

            this.tempOrderItems.forEach((item) => {
              item.selected = false;
              item.perPrice = 0;
              item.number = Number(item.number);
              item.type = item.type ? item.type : "دست";
            });
            this.selectedItems = new Array(this.tempOrderItems.length).fill(
              false
            );

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////

            // if (
            //   this.orderInfo.status == "تعیین قیمت توسط مدیر عامل" ||
            //   this.orderInfo.status == "بررسی تعیین قیمت توسط مدیر فروش" ||
            //   this.orderInfo.status == "آماده برای امضا" ||
            //   this.role == "ceo" ||
            //   this.role == "salesManager"
            // )
            //   this.onlyChangePrice = true;

            // this.getCustomerHistory();
            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    upload() {},
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    toggleSelectAll() {
      this.vLoading = true;
      this.updateTableBusy = true;
      if (
        this.tempOrderItems.length ==
        this.tempOrderItems.filter((x) => x.selected).length
      )
        this.tempOrderItems.forEach((element) => {
          element.selected = false;
        });
      else
        this.tempOrderItems.forEach((element) => {
          element.selected = true;
        });

      setTimeout(() => {
        this.vLoading = false;
        this.updateTableBusy = false;
      }, 250);
    },
    syncUpdateTable() {
      this.updateTableBusy = true;
      setTimeout(() => {
        this.updateTableBusy = false;
      }, 250);
    },
    bulkUpdate() {
      this.vLoading = true;
      this.tempOrderItems.forEach((item) => {
        if (item.selected) {
          this.myFields.forEach((field) => {
            if (this.updateAllItems[0][field.key]) {
              item[field.key] = this.updateAllItems[0][field.key];
            }
          });
        }
      });
      setTimeout(() => {
        this.vLoading = false;
      }, 250);
    },
  },

  computed: {
    myFields() {
      let myfields = [];

      myfields = this.hasCustomerIndex ? this.fieldsCI : this.fields;

      // if (!this.hasSizeStandard) {
      //   myfields = myfields.filter((x) => x.key != "dimensionStandard");
      // }

      myfields = myfields.filter((x) => x.key != "perPrice");
      myfields = myfields.filter((x) => x.key != "totalPrice");

      return myfields;
    },
    filtered() {
      const filtered = this.tempOrderItems.filter((item) => {
        return Object.keys(this.filters).every((key) =>
          String(item[key])
            .toLowerCase()
            .includes(this.filters[key].toLowerCase())
        );
      });
      return filtered;
    },
  },
  created() {
    this.getTaskInfo();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
textarea {
  padding: 2px !important;
}

hr {
  border: none;
  border-top: 3px double #333;
  color: #333;
  overflow: visible;
  text-align: center;
  height: 5px;
}

.VIP {
  background-color: rgb(150, 111, 13);
  color: white;
}

.معمولی {
  background-color: rgb(3, 25, 135);
  color: white;
}

.لیست {
  background-color: rgb(224, 10, 10);
  color: black;
}
</style>
